/* Polsk katalog for locale-settings-integrations-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'set.integr.wooImported': 'Zaimportowane zdarzenia sprzedaży i zwrotów: {orders}',
  'set.integr.wooLastSync': 'Ostatnia synchronizacja {date}',
  'set.integr.wooDisconnectTitle': 'Odłącz WooCommerce',
  'set.integr.wooDisconnectHelp': 'Plumme przestanie pobierać nowe zamówienia i zwroty. Już zaimportowane zdarzenia i zaksięgowane rozliczenia dzienne zostaną zachowane wraz ze ścieżką audytu.',
  'set.integr.wooDisconnectedToast': 'WooCommerce został odłączony.',
  'set.integr.wooDisconnectError': 'Nie udało się odłączyć WooCommerce.',
  'set.integr.wooUnavailable': 'Integracja z WooCommerce nie jest dostępna w tej wersji.',
});
